'use client';

import clsx from 'clsx';
import { motion, useScroll, useTransform } from 'framer-motion';
import { useRef } from 'react';
import { HeadingMarkdown } from '../HeadingMarkdown/HeadingMarkdown';

import { ImageClient, RichText } from '@/components/core';
import { AssetStoryblok, RteStoryblok } from '@/types/storyblok/storyblok-types';
import styles from './ScrollSections.module.scss';

type MotionScrollEffectProps = {
    titleFirstSection: any;
    description: RteStoryblok;
    asset: AssetStoryblok;
};

const MotionScrollEffect = ({ titleFirstSection, description, asset }: MotionScrollEffectProps) => {
    const ref = useRef(null);
    const { scrollYProgress } = useScroll({
        target: ref,
        offset: ['start end', 'end 120%'],
    });

    const backgroundColor = useTransform(
        scrollYProgress,
        [0, 0.5],
        ['rgba(205, 205, 205, 0.7)', 'rgba(241, 243, 245, 1)'],
    );
    // const width = useTransform(scrollYProgress, [0.1, 0.5], ['70%', '100%']);
    const borderRadius = useTransform(scrollYProgress, [0, 0.5], ['3px', '0%']);

    return (
        <motion.div
            ref={ref}
            style={{
                backgroundColor,
                width: '100%',
                borderTopRightRadius: borderRadius,
                borderTopLeftRadius: borderRadius,
            }}
            className={styles.firstSection}
        >
            <div className={clsx(styles.inner, 'container')}>
                <div className={clsx(styles.titleWrap)}>
                    <HeadingMarkdown as="h2">{titleFirstSection}</HeadingMarkdown>
                    {description && (
                        <div className={styles.descriptionWrapper}>
                            <RichText
                                classNameRoot={(styles.description, 'p')}
                                document={description}
                            />
                        </div>
                    )}
                </div>
                {asset?.filename && (
                    <div className={clsx(styles.secondSection)}>
                        <ImageClient
                            className={styles.image}
                            width={486}
                            height={560}
                            sizes="(max-width: 600px) 480px, 768px"
                            loading="eager"
                            src={asset?.filename}
                            alt={asset?.alt}
                            focalPoints={asset?.focus}
                            jsonData={{
                                images: [
                                    {
                                        contentUrl: asset?.filename,
                                        copyrightNotice: asset?.copyright,
                                    },
                                ],
                            }}
                        />
                    </div>
                )}
            </div>
        </motion.div>
    );
};

export default MotionScrollEffect;
